import { render } from "./WorkflowConversionModal.vue?vue&type=template&id=04bc8870&scoped=true"
import script from "./WorkflowConversionModal.vue?vue&type=script&lang=js"
export * from "./WorkflowConversionModal.vue?vue&type=script&lang=js"

import "./WorkflowConversionModal.vue?vue&type=style&index=0&id=04bc8870&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04bc8870"]])

export default __exports__